import { Link } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useReactivateAccountMutation } from "@/redux/apis/client/clientApi";
import { addToast } from "@/utils";
import { useClientsContext } from "../context";
import { getManageAccountPath } from "../helpers";
import { ClientsConfirmStep } from "./ClientsConfirmStep";

interface ClientsReactivateProps {
  onClose: () => void;
}

/** Confirm step before reactivating a removed client (DEV-1177, Figma 3714-39860). */
export const ClientsReactivate = ({ onClose }: ClientsReactivateProps) => {
  const { selectedClient } = useClientsContext();
  const [reactivateAccount, { isLoading }] = useReactivateAccountMutation();

  const onConfirm = () => {
    if (!selectedClient) return;

    reactivateAccount(selectedClient.id)
      .unwrap()
      .then(() => {
        addToast("success", `Reactivated access for ${selectedClient.name}`);
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <ClientsConfirmStep title="Reactivate Client" confirmLabel="Reactivate" isLoading={isLoading} onConfirm={onConfirm} onClose={onClose}>
      <Typography variant="paragraph">
        Are you sure you want to reactivate{" "}
        {selectedClient && (
          <Link to={getManageAccountPath(selectedClient.id)} className="inline-flex hover:text-info" target="_blank">
            {`${selectedClient.name}'s`}
          </Link>
        )}{" "}
        Access to RideMinder?
      </Typography>
    </ClientsConfirmStep>
  );
};
